//import Redrag from './redrag';

import builder from './builder/re-builder';
const $ = jQuery;
builder();
$('[data-toggle="tooltip"]').tooltip({
  trigger: 'hover',
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/frontend.js
 **/